import { Button } from "@ucl/dse/button";
import React from "react";

interface LinkButtonProps {
    config: { url: string; openNewTab: boolean };
    children: React.ReactNode;
    ariaLabel?: string;
    variant?: "primary" | "secondary" | "tertiary";
    className?: string;
    style?: React.CSSProperties;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const LinkButton: React.FC<LinkButtonProps> = ({
    config,
    children,
    ariaLabel,
    variant = "primary",
    className = "",
    style,
    onClick,
}) => (
    <Button
        as="a"
        href={config.url}
        target={config.openNewTab ? "_blank" : "_self"}
        rel={config.openNewTab ? "noopener noreferrer" : undefined}
        aria-label={ariaLabel}
        variant={variant}
        className={className}
        style={style}
        onClick={onClick as unknown as React.MouseEventHandler<HTMLButtonElement>}
    >
        {children}
    </Button>
);
